
import { ReactNode, useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import GeneralProductSearch from "@components/dynamic/GeneralProductSearch";
import { ProductDataType } from "@/api/ProductsApi";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";
import { TAXES_PERCENTAGES_VALUES } from "@utils/Constants";
import { useAppDispatch } from "@/store/hooks";
import { addProduct } from "@/store/slices/eDocumentSlides";
import { showAlert } from "@utils/Alert";
import { HiddenableContainer } from "@components/layout/HiddenableContainer";
import GenerateTemporalProduct from "@components/dynamic/GenerateTemporalProduct";
import { OpenAddProductPubSub, OpenAddProductPubSubPayload } from "@utils/pubsubs/PubSub";
import { removeFunctionFromObject } from "@utils/Utils";
import { formatCant } from "@utils/Cant";
import { InvoiceTemplateDataType } from "@/api/InvoiceTemplateApi";
import InvoiceTemplateSearch from "@components/dynamic/InvoiceTemplateSearch";

type AddProductToDocumentOffCanvasProps = {
    hideTemplate?: boolean,
    hideTemporal?: boolean,
    editablePrice?: boolean,
    calculateTaxes?: boolean,
    defaultSearchType?: SearchType,
    productSelection?: boolean
    useProductCost?: boolean
    onTemplateSelect?: (invoiceTemplate: InvoiceTemplateDataType) => void
    onProductSelect?: (product: EDocumentProductDataType) => void
} & DefaultOffCanvasProps

type SearchType = "temp" | "general" | "original" | "template" | "";
type SearchButtonProp = {
    type: SearchType;
    label: string;
    shortcut?: string
}

const AddProductToDocumentOffCanvas = (props: AddProductToDocumentOffCanvasProps) => {
    const dispatch = useAppDispatch()
    const { btnColor = "primary", editablePrice = false, calculateTaxes = false, className, hideTemplate = false, onProductSelect, productSelection = false,
        hideTemporal = false, onTemplateSelect, defaultSearchType = "", useProductCost = false } = props;
    const [isOpen, setOpen] = useState(false);
    const [searchType, setSearchType] = useState<SearchType>("");
    const searchButtons: SearchButtonProp[] = [
        { type: "temp", label: "Producto Temporal", shortcut: "F6" },
        { type: "general", label: "Busqueda General", shortcut: "F7" },
        // { type: "original", label: "Numero Original", shortcut: "F8" },
        { type: "template", label: "Plantillas" },
    ];

    useEffect(() => {
        setSearchType(defaultSearchType);
    }, [defaultSearchType]);

    useEffect(() => {
        const unsubscribe = OpenAddProductPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenAddProductPubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
    }


    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const addProductToDocument = (product: ProductDataType, cant: number, overridedPrice?: number, reCalculatePrice: boolean = false) => {

        const productToAdd: EDocumentProductDataType = {
            productId: product.id,
            exento: product.exento,
            tipo_producto: product.tipo_producto,
            description: product.descripcion_fact,
            codigo: product.codigo,
            cant: cant,
            price: overridedPrice || 0,
            porcentaje_impuesto: TAXES_PERCENTAGES_VALUES[`${product.porcentaje_impuesto}`],
            codigo_tarifa: product.porcentaje_impuesto,
            tipo_impuesto: product.tipo_impuesto,
            unidad_medida: product.unidad_medida,
            comision: 0,
            codigo_cabys: product.codigo_cabys,
            porcentaje_descuento: 0,
            descuento: 0,
            impuestos: 0,
            impuestos_servicio: 0,
            product: product,
            forceRecalculatePrice: reCalculatePrice,
        }
        if (productSelection) {
            if (onProductSelect) {
                onProductSelect(productToAdd)
            }
        } else if (productToAdd.cant) {
            dispatch(addProduct(removeFunctionFromObject(productToAdd)));
            const didAddSingle = productToAdd.cant === 1;
            showAlert("success", `Se ${didAddSingle ? 'agrego' : 'agregaron'} ${formatCant(productToAdd.cant)} ${didAddSingle ? 'unidad' : 'unidades'} del producto ${productToAdd.codigo || ""}`, {}, 2000)
        }
    }

    const getSelectorColor = (type: SearchType): string | undefined => {
        if (searchType === "" || type === searchType) {
            return "primary"
        }
    }

    const renderSearchButtons = (): ReactNode[] => {
        return searchButtons
            .filter(s => !hideTemplate || s.type != "template")
            .filter(s => !hideTemporal || s.type != "temp")
            .map(({ type, label, shortcut }) => (
                <Button
                    key={type}
                    color={getSelectorColor(type)}
                    size="lg"
                    type="button"
                    onClick={() => setSearchType(type)}
                    className="me-2"
                >
                    {/* {label} {shortcut && `(${shortcut})`} */}
                    {label}
                </Button>
            ));
    }

    const triggerOnTemplateSelect = (t: InvoiceTemplateDataType) => {
        if (onTemplateSelect) {
            onTemplateSelect(t);
        }
        showAlert("success", "La plantilla de facturacionha sido cargada adecuadamente")
        setOpen(false);
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>)}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Buscar Producto
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <HiddenableContainer
                            show={searchType == ""}>
                            <p>
                                Seleccione como opcion
                            </p>
                        </HiddenableContainer>
                        <div className={styles.addOptions}>
                            {renderSearchButtons()}
                        </div>

                        <div className="mt-4">
                            <HiddenableContainer
                                show={searchType === "temp"}>
                                <GenerateTemporalProduct
                                    onProductGenerated={(...args) => addProductToDocument(...args, undefined, true)}
                                />
                            </HiddenableContainer>
                            <HiddenableContainer
                                show={searchType === "general"}>
                                <GeneralProductSearch
                                    useProductCost={useProductCost}
                                    editablePrice={editablePrice}
                                    calculateTaxes={calculateTaxes}
                                    productSelection={productSelection}
                                    onProductSelect={(...args) => addProductToDocument(...args, true)}
                                />
                            </HiddenableContainer>
                            <HiddenableContainer
                                show={searchType === "template"}>
                                <InvoiceTemplateSearch
                                    onTemplateSelect={(...args) => { triggerOnTemplateSelect(...args) }}
                                />
                            </HiddenableContainer>
                        </div>
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default AddProductToDocumentOffCanvas;
